import React from 'react';
import { useTranslation } from 'react-i18next';

import { WebToolsetSettings, ToolsetModel } from '../../../../../../gamma-api';
import IbNumberInput from '../../../../../components/common/IbNumberInput';
import IbTextArea from '../../../../../components/common/IbTextArea';
import { tryParseFloatValue, tryParseIntValue } from '../../../../../utils/numberUtil';
import IbTypography from '../../../../../components/common/IbTypography';

import { FORM_ITEM_CLASS_NAME, PARAMETERS_CLASS_NAME } from './const';

export interface IWebParametersProps {
  editToolset: ToolsetModel;
  onChange: (toolset: ToolsetModel) => void;
}

const WebParameters: React.FC<IWebParametersProps> = ({ editToolset, onChange }) => {
  const { t } = useTranslation();
  const fetchUrlToolSettings = (editToolset.settings as WebToolsetSettings).fetch_url_tool_settings;

  const onMaxContentLengthChange = (value: string | number) => {
    onChange({
      ...editToolset,
      settings: {
        ...editToolset.settings,
        fetch_url_tool_settings: {
          ...fetchUrlToolSettings,
          max_content_token_count: tryParseIntValue(value) ?? 0,
        },
      },
    } as ToolsetModel);
  };

  const onTimeoutChange = (value: string | number) => {
    onChange({
      ...editToolset,
      settings: {
        ...editToolset.settings,
        fetch_url_tool_settings: {
          ...fetchUrlToolSettings,
          fetch_timeout_seconds: tryParseFloatValue(value) ?? 0,
        },
      },
    } as ToolsetModel);
  };

  const onAllowedHostsChange = (value: string) => {
    onChange({
      ...editToolset,
      settings: {
        ...editToolset.settings,
        fetch_url_tool_settings: {
          ...fetchUrlToolSettings,
          allowed_hosts: value.split('\n').map((host) => host.trim()), // TODO: better function
        },
      },
    } as ToolsetModel);
  };

  return (
    <div className={PARAMETERS_CLASS_NAME}>
      <div className={FORM_ITEM_CLASS_NAME}>
        <IbTypography.Paragraph strong type="secondary">
          {t('Agent: Toolset: Modal: Settings: Max content length: Title')}
        </IbTypography.Paragraph>
        <IbNumberInput
          min={0}
          precision={0}
          value={fetchUrlToolSettings.max_content_token_count}
          onChange={onMaxContentLengthChange}
        />
      </div>
      <div className={FORM_ITEM_CLASS_NAME}>
        <IbTypography.Paragraph strong type="secondary">
          {t('Agent: Toolset: Modal: Settings: Timeout: Title')}
        </IbTypography.Paragraph>
        <IbNumberInput
          min={0}
          precision={0}
          value={fetchUrlToolSettings.fetch_timeout_seconds}
          onChange={onTimeoutChange}
        />
      </div>
      <div className={FORM_ITEM_CLASS_NAME}>
        <IbTypography.Paragraph strong type="secondary">
          {t('Agent: Toolset: Modal: Settings: Allowed hosts: Title')}
        </IbTypography.Paragraph>
        <IbTextArea
          placeholder={t('Agent: Toolset: Modal: Settings: Allowed hosts: Placeholder')}
          rows={5}
          value={(fetchUrlToolSettings.allowed_hosts || []).join('\n')}
          onChange={onAllowedHostsChange}
        />
      </div>
    </div>
  );
};

export default WebParameters;
